export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/33059925aedb8e7ecebe0f38d6820964/5b68232d399265631754919c6935f83b.png" 
                alt="TOKAN補助金コンサルタント" 
                className="w-10 h-10 object-contain"
              />
              <div>
                <h3 className="font-bold text-lg">TOKAN</h3>
                <p className="text-xs text-gray-400">補助金コンサルタント</p>
              </div>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed mb-4">
              補助金 × 法務 × LP制作を一気通貫で支援する、神奈川・東京の中小企業専用パートナー
            </p>
            <div className="space-y-2 text-sm text-gray-400">
              <p className="font-semibold text-white">株式会社Alice-Link</p>
              <p className="flex items-center gap-2">
                <i className="ri-mail-line text-blue-400"></i>
                <a href="mailto:info@alicelink.com" className="hover:text-white transition-colors">
                  info@alicelink.com
                </a>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-phone-line text-blue-400"></i>
                <a href="tel:08073973298" className="hover:text-white transition-colors">
                  080-7397-3298
                </a>
              </p>
            </div>
          </div>

          <div>
            <h4 className="font-bold mb-4">サービス</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><button onClick={() => scrollToSection('services')} className="hover:text-white transition-colors cursor-pointer">補助金・助成金サポート</button></li>
              <li><button onClick={() => scrollToSection('services')} className="hover:text-white transition-colors cursor-pointer">法務サポート</button></li>
              <li><button onClick={() => scrollToSection('services')} className="hover:text-white transition-colors cursor-pointer">LP制作・マーケティング</button></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-4">料金プラン</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><button onClick={() => scrollToSection('pricing')} className="hover:text-white transition-colors cursor-pointer">ライトプラン</button></li>
              <li><button onClick={() => scrollToSection('pricing')} className="hover:text-white transition-colors cursor-pointer">経費削減プラン</button></li>
              <li><button onClick={() => scrollToSection('pricing')} className="hover:text-white transition-colors cursor-pointer">補助金 × 集客支援プラン</button></li>
              <li><button onClick={() => scrollToSection('pricing')} className="hover:text-white transition-colors cursor-pointer">完全フル支援プラン</button></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-4">お問い合わせ</h4>
            <ul className="space-y-3 text-sm text-gray-400">
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-blue-400"></i>
                <span>神奈川県横浜市</span>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="flex items-center gap-2 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-mail-line text-blue-400"></i>
                  <span>お問い合わせフォーム</span>
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              &copy; 2024 TOKAN補助金コンサルタント. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-white transition-colors"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
